import { gaEvent } from '~/plugins/gtagGA4.js'

export default {
  data () {
    return {
      _handleClick: null
    }
  },
  watch: {
    polygon: {
      handler (value) {
        this.updatePolygon(value)
      },
      deep: true
    }
  },
  beforeDestroy () {
    // debugger
  },
  methods: {
    polygonComponents () {
      const polygon = this.polygon
      const updatePolygon = this.updatePolygon

      if (!AFRAME.components.polygon) {
        AFRAME.registerComponent('polygon', {
          init () {
            // debugger
            updatePolygon(polygon) // removing b/c it causes duplicates w/ handler
          },
          remove () {
            if (this.el.getObject3D('mesh') != null) {
              this.el.removeObject3D('mesh')
              delete AFRAME.components.polygon
            }
          }
        })
      }
    },
    showLoadingModel () {
      const loadingComponent = document.querySelector('[loading]')
      if (loadingComponent) {
        loadingComponent.setAttribute('gltf-model', '/gltf/drops_loading.glb')
        loadingComponent.setAttribute('position', '0 9 0')

        loadingComponent.setAttribute(
          'animation',
          'property: rotation; to: 0 0 360; loop: true; dur: 3000; easing: linear;'
        )
      }
    },
    updatePolygon (polygon) {
      this.showLoadingModel()
      const polygonComponent = document.querySelector('[polygon]')

      // override material check
      const dropScene = document.querySelector('[drop-scene]')

      // debugger
      if (polygon) {
        dropScene.setAttribute('env-map', {
          matOverride:
            polygon.material && polygon.material.override
              ? polygon.material.override
              : false,
          resolution: 256,
          repeat: true,
          interval: 50,
          roughness: 0.1,
          metalness: 1.0
        })
      } else {
        polygonComponent.setAttribute('visible', false)
      }
      // const test = cubeCamera.getDOMAttribute('env-map')

      const onModelProgress = function (evt) {
        console.log(evt.target.progress, evt.progress)
      }

      const onModelLoaded = function (evt) {
        // console.log('The polygonComponent entity loaded')

        // WIP
        const loadingComponent = document.querySelector('[loading]')
        if (loadingComponent) {
          const dropScene = document.querySelector('[drop-scene]')
          dropScene.removeChild(loadingComponent)
        }

        gaEvent({ event: 'polygon_loaded', params: {} })
        const gltf = evt.detail.model // This is the THREE.js GLTF scene
        console.log('GLTF Scene Loaded:', gltf)

        // Store the scene object reference instead of trying to store the whole GLTF
        window.loadedGLTFScene = gltf

        polygonComponent.removeEventListener('model-loaded', onModelLoaded)
        polygonComponent.removeEventListener('model-error', onModelError)
      }

      const onModelError = function (evt) {
        // console.log('The polygonComponent entity didnt load: ' + evt.error)
        polygonComponent.removeEventListener('model-loaded', onModelLoaded)
        polygonComponent.removeEventListener('model-error', onModelError)
      }

      // polygonComponent.keys(window).forEach((key) => {
      //   console.log('key ' + key)
      // })

      polygonComponent.addEventListener('model-onProgress', onModelProgress)
      polygonComponent.addEventListener('model-loaded', onModelLoaded)
      polygonComponent.addEventListener('model-error', onModelError)

      const attributionElement = document.querySelector('[polygon-attribution]')
      let description = ''

      if (polygon) {
        if (polygon.formats) {
          polygon.formats.forEach((format) => {
            if (
              format.formatType === 'GLB' ||
              format.formatType === 'GLTF' ||
              format.formatType === 'GLTF2'
            ) {
              if (format.root.contentType === 'model/gltf+json') {
                polygonComponent.setAttribute('gltf-model', format.root.url)
              }
            }
          })
        }

        // change this to convert 100% to 1
        if (polygon.scale) {
          const scale = polygon.scale
          polygonComponent.setAttribute('scale', `${scale} ${scale} ${scale}`)
        }

        if (polygon.position) {
          const position = polygon.position
          polygonComponent.setAttribute('position', `${position}`)
        }

        this._handleClick = () => {
          if (polygon.link) {
            const link = polygon.link
            $nuxt.$emit('actionClick', { link })
          }
        }

        // HANDLE POLGYGON CLICK
        polygonComponent.removeEventListener('click', this._handleClick)
        polygonComponent.addEventListener('click', this._handleClick)

        // Backwards compatibility for past drops without 'rotate' in polygon
        if (polygon.rotate || !('rotate' in polygon)) {
          polygonComponent.setAttribute(
            'animation',
            'property: rotation; to: 0 360 0; loop: true; dur: 30000; easing: linear; dir: reverse'
          )
        } else {
          polygonComponent.setAttribute('rotation', '0 0 0')
          polygonComponent.removeAttribute('animation')
        }

        if (polygon.authorName) {
          if (polygon.description) {
            description = polygon.description
              .split('', 30)
              .reduce(
                (o, c) => (o.length === 29 ? `${o}${c}...` : `${o}${c}`),
                ''
              )
          } else {
            description = '3D artwork'
          }

          if (attributionElement) {
            attributionElement.setAttribute(
              'text',
              'value',
              `${description} by ${polygon.authorName}`
            )
          }
        } else if (attributionElement) { attributionElement.setAttribute('text', 'value', '') }
      }
    }
  }
}
